<template>
  <LinkTable
    label="6.1.1 Work Management Metrics Links"
    :links="store.plan.work_management_metrics_links"
    :readonly="readonly"
    @add="addLink($event)"
    @update="updateLink($event.id, $event.link)"
    @delete="deleteLink($event)"
  />
</template>

<script setup lang="ts">
import { useAMPStore } from "@/store/asset-management-plan";
import LinkTable from "./LinkTable.vue";
import { WorkManagementMetricsLink } from "@/classes";

const props = defineProps<{
  readonly?: boolean;
}>();

const emit = defineEmits<{
  delete: [item: WorkManagementMetricsLink];
}>();

const store = useAMPStore();

const addLink = (link: string) => {
  const newLink = new WorkManagementMetricsLink();
  newLink.asset_management_plan_id = store.plan.id;
  newLink.link = link;
  store.plan.work_management_metrics_links.push(newLink);
};

const updateLink = (id: string, value: string) => {
  const link = store.plan.work_management_metrics_links.find(
    (l) => l.id === id,
  );
  if (link) {
    link.link = value;
  }
};

const deleteLink = (id: string) => {
  const index = store.plan.work_management_metrics_links.findIndex(
    (l) => l.id === id,
  );
  if (index !== -1) {
    const link = store.plan.work_management_metrics_links[index];
    store.plan.work_management_metrics_links.splice(index, 1);
    emit("delete", link);
  }
};
</script>
